import { cateringRequest, cateringRequestHide, cateringUploadsHide } from '@/utils/fetch'

// 项目终止 添加接口
export function saveProjectStop(data) {
  const url = '/api/project_stop/save'
  return cateringRequest.post(url, data)
}
